import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export const DemoStore = {
    namespaced: true,
    state: () => ({
        sections: [
            "Features", 
            "Platforms",
            "Products",
            "Product Review",
            "Frequency",
            "Category & Search Terms",
            "Pincodes"
        ],
        selectedSection: "",
        loader: false,
        totalFeatures: null,
        selectedFeatures: [],
        totalPlatforms: [],
        selectedPlatforms: [],
        updatedDateTimeStamp: ""
    }),
    mutations: {
        SET_TIMESTAMP(state, time) {
            state.updatedDateTimeStamp = "";
            state.updatedDateTimeStamp = time;
        },
        SET_SECTIONS(state, sections) {
            state.sections = sections;
        },
        SET_SELECTED_SECTION(state, section) {
            state.selectedSection = section;
        },
        SET_LOADER(state, loader) {
            state.loader = loader;
        },
        SET_TOTAL_FEATURES(state, features) {
            state.totalFeatures = features;
        },
        SET_SELECTED_FEATURES(state, selectedFeatures) {
            state.selectedFeatures = selectedFeatures;
        },
        SET_TOTAL_PLATFORMS(state, platforms) {
            state.totalPlatforms = platforms;
        },
        SET_SELECTED_PLATFORMS(state, selectedPlatforms) {
            state.selectedPlatforms = selectedPlatforms;
        },
    },
    actions: {
        setSections({commit}, sections) {
            commit('SET_SECTIONS', sections)
        },
        setSelectedSection({ commit }, section) {
            commit('SET_SELECTED_SECTION', section)
        },
        setDemoLoader({ commit }, loader) {
            commit('SET_LOADER', loader)
        },
        setTotalFeatures({ commit }, features) {
            commit('SET_TOTAL_FEATURES', features)
        },
        setSelectedFeatures({ commit }, selectedFeatures) {
            commit('SET_SELECTED_FEATURES', selectedFeatures)
        },
        setTotalPlatforms({ commit }, platforms) {
            commit('SET_TOTAL_PLATFORMS', platforms)
        },
        setSelectedPlatforms({ commit }, selectedPlatforms) {
            commit('SET_SELECTED_PLATFORMS', selectedPlatforms)
        },
        setTimeStamp({ commit }, time) {
            commit('SET_TIMESTAMP', time)
        }
    }
}

const store = new Vuex.Store({
    modules: {
        DemoStore
    }
});

export default store;